import React from "react";
import Modal from "react-bootstrap/Modal";
//import { useTranslation } from "react-i18next";
import EXCLAMATIONICON from "../../images/exclamationicon.svg";
import AppStyles from "../../config/styles";
import {AddChildCloseIcon} from "../atoms/ConnectStories";
// import { NewChildPopupTitle } from "../atoms/FeedsPopup";
import { Div } from "../atoms/Div";

const styles = {
  modal: {
    justifyContent: "flex-end",
    margin: 0,
  },
  viewstyle: {
    backgroundColor: "white",
    borderTopRightRadius: "12px",
    borderTopLeftRadius: "12px",
  },
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },
  iconstyle: {
    marginTop: "25px",
    marginLeft: "6%",
  },
  titlestyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "25px",
    color: "black",
    marginLeft: "10%",
    
  },
  desstyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "18px",
    color: "black",
    marginTop: "15px",
    marginLeft: "20px",
    marginRight: "15px",
    alignSelf: "center",
  },
  galleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    marginLeft: "35%",
    marginRight: "15px",
    marginTop: "25px",
    paddingTop: "15px",
    paddingBottom: "15px",
    textAlign: "center",
    width: "30%"
  },
  gallerytextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "20px",
    fontFamily: "Lato-Bold",
  },
  camerapressstyle: {
    padding: 10,
    textAlign: "center",
  },
  cameratextstyle: {
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    color: AppStyles.colors.COLOR_GREY3,
    textDecorationLine: "underline",
    alignSelf: "center",
    marginTop: "25px",
    marginBottom: "30px"
  },
};

function WipeOutModal(props) {

  return (
    <Modal
      show={props?.isVisible}
      onBackButtonPress={props?.onClose}
      onBackdropPress={props?.onClose}
      style={styles.modal}
    >
         <AddChildCloseIcon  onClick={props?.onClose}>X</AddChildCloseIcon>
      <div style={styles.viewstyle}>
        <span style={styles.titlestyle}>{props?.title}</span>
          <Div flexdiv> 
          <img src={EXCLAMATIONICON} style={styles.iconstyle} height={60} width={60} alt=""/>
          <p style={styles.desstyle}>{props?.textValue}</p>
          </Div>
          <Div flexdiv draftSaveButton onClick={props?.onProceedClick}>
            <div style={styles.galleryviewstyle}>
              <span style={styles.gallerytextstyle}>{props?.onProceedText}</span>
            </div>
          </Div>
          <Div style={styles.camerapressstyle} onClick={props?.onCancelClick}>
            <span style={styles.cameratextstyle}>{props?.onCancelText}</span>
          </Div>
        </div>
    </Modal>
  );
}

export default WipeOutModal;
